import { render, staticRenderFns } from "./MtsOdemeView.vue?vue&type=template&id=a90e11ca"
import script from "./MtsOdemeView.vue?vue&type=script&lang=ts"
export * from "./MtsOdemeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports